import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   static targets = [ "select", "typeInput", "submitButton" ]
   static values = { confirmMessage: String }

   update() {
      const tomselect = this.selectTarget.tomselect
      const value = tomselect?.getValue()
      const type = (value && tomselect?.options[value]?.type) || "entry"

      this.typeInputTarget.value = type

      if (type === "source") {
         this.submitButtonTarget.dataset.turboConfirm = this.confirmMessageValue
      } else {
         delete this.submitButtonTarget.dataset.turboConfirm
      }
   }
}